// extracted by mini-css-extract-plugin
export var button = "_ez-4";
export var hasDarkBackground = "_ez-7";
export var hasLightBackground = "_ez-6";
export var iconWrapper = "_ez-0";
export var large = "_ez-2";
export var medium = "_ez-1";
export var small = "_ez-5";
export var xsmall = "_ez-3";